const CATEGORY_SLUGS = {
  고속인쇄기: "high-speed-printer",
  디자인용복합기: "design-copier",
  대형복합기: "office-copier",
  사무용복합기: "office-copier",
  소형복합기: "compact-copier",
  프린터: "printer",
  토너와소모품: "toner-supplies",
  토너소모품: "toner-supplies",
};

export function storeCategorySlug(value = "") {
  return CATEGORY_SLUGS[String(value).replace(/[\s·ㆍ]/g, "")] || value;
}

// Homepage configuration and old bookmarks still contain the former routes.
export function normalizePublicLink(link, fallback = "/store") {
  if (!link || typeof link !== "string") return fallback;
  try {
    const url = new URL(link, "https://ikoffices.com");
    if (!["ikoffices.com", "www.ikoffices.com"].includes(url.hostname)) return fallback;
    if (url.pathname === "/products" || url.pathname.startsWith("/products/")) {
      url.pathname = url.pathname.replace(/^\/products/, "/store");
    }
    if (url.pathname === "/store" && url.searchParams.has("분류")) {
      const category = storeCategorySlug(url.searchParams.get("분류"));
      if (Object.values(CATEGORY_SLUGS).includes(category)) {
        url.pathname = `/store/${category}`;
        url.searchParams.delete("분류");
      }
    }
    if (url.pathname === "/inquiry" || (url.pathname === "/erp" && url.searchParams.get("section") === "inquiry")) {
      url.pathname = "/consultation";
      url.searchParams.delete("section");
      if (!url.searchParams.has("tab")) url.searchParams.set("tab", "rental");
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallback;
  }
}

export function consultationSelection(search) {
  const params = new URLSearchParams(search);
  const requested = params.get("tab");
  const tab = requested === "service" ? "general" : requested;
  const type = requested === "service" ? "as" : params.get("type");
  return {
    tab: ["rental", "general", "live", "global"].includes(tab) ? tab : "rental",
    type: ["purchase", "toner", "as", "etc"].includes(type) ? type : "etc",
  };
}
